'use strict';

angular.module('mean.system-lots').factory('lotService', ['$filter', 'SystemLots', 'toaster', '$q',
    function($filter, SystemLots, toaster, $q) {
        //lot: lot number
        var db = function(trade_code, company_code, project_id) {
            var deferred = $q.defer();

            SystemLots.query({'company_code': company_code,
                'trade_code': trade_code, 'project_id': project_id}, function(systemLots) {                
                if(systemLots.length === 0) {
                    var newEntry = new SystemLots({
                        'company_code': company_code,
                        'trade_code': trade_code,
                        'project_id': project_id
                    });

                    newEntry.$save(function(success) {
                        deferred.resolve(success);
                    }, function(error) {
                        // toaster.pop('error', 'System Lot Save Error', error);
                        // deferred.resolve(false);
                    })
                } else if(systemLots.length === 1) {
                    deferred.resolve(systemLots[0]);
                }
            });

            return deferred.promise;
        }

        var add = function(lot, phase, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot,
                    'phase': phase }, true);

                if(sched.length === 1) {
                    sched[0].active = false;
                    sched[0].date_added = new Date();
                    sched[0].completed = false;
                    sched[0].rescheduled = false;
                } else if(sched.length === 0) {
                    var newLot = {
                        'number': lot,
                        'phase': phase,
                        'date_added': new Date()
                    }
                    success.lots.push(newLot);
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        };

        var getLatterDate = function(start_date) {
            var today = moment();
            var start = moment(start_date);
            return (today > start) ? new Date(today) : new Date(start_date);
        };

        var schedule = function(lot, trade_code, company_code, project_id) {
            console.log('System lot scheduling ' + lot.number);
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot.number,
                    'phase': lot.phase }, true);

                if(sched.length !== 1) { //first time we've see this lot
                    var newLot = {
                        'number': lot.number,
                        'phase': lot.phase,
                        'date_added': new Date(),
                        'active': true,
                        'date_scheduled': new Date(lot.start_date)
                    }
                    success.lots.push(newLot);
                } else {
                    sched[0].active = true;
                    sched[0].date_scheduled = new Date(lot.start_date);
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }

        var reschedule = function(lot, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot.number,
                    'phase': lot.phase }, true);

                if(sched.length !== 1) { //first time we've see this lot
                    var newLot = {
                        'number': lot.number,
                        'phase': lot.phase,
                        'active': true,
                        'date_added': new Date(),
                        'date_rescheduled': [new Date()],
                        'rescheduled': true
                    }
                    success.lots.push(newLot);
                } else {
                    sched[0].active = true;            
                    sched[0].rescheduled = true;
                    if(!sched[0].date_rescheduled) {
                        sched[0].date_rescheduled = [];
                    }
                    sched[0].date_rescheduled.push(new Date);
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }

        var complete = function(lot, phase, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot,
                    'phase': phase }, true);

                if(sched.length !== 1) { //first time we've see this lot
                    var newLot = {
                        'number': lot,
                        'phase': phase,
                        'date_added': new Date(),
                        'completed': true,
                        'active': true,
                        'date_completed': new Date()
                    }
                    success.lots.push(newLot);
                } else {
                    sched[0].active = true;
                    sched[0].completed = true;
                    sched[0].date_completed = new Date;
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }

        var remove = function(lot, phase, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot,
                    'phase': phase }, true);

                if(sched.length === 1) { //first time we've see this lot
                    var idx = success.lots.indexOf(sched[0])
                    success.lots.splice(idx, 1);
                } else if(sched.length > 1){
                    toaster.pop('error', 'System Lot DB Error', 'Too many lots.  Contact Admin');
                    return;
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }

        var reset = function(lot, phase, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot,
                    'phase': phase }, true);

                if(sched.length !== 1) { //first time we've see this lot
                    var newLot = {
                        'number': lot,
                        'phase': phase,
                        'date_added': new Date(),
                        'active': false,
                        'date_reset': new Date()
                    }
                    success.lots.push(newLot);
                } else {
                    sched[0].active = false;
                    sched[0].rescheduled = false;
                    sched[0].completed = false;
                    sched[0].date_reset = new Date;
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }

        var reopen = function(lot, phase, trade_code, company_code, project_id) {
            db(trade_code, company_code, project_id).then(function(success) {
                var sched = $filter('filter')(success.lots, {
                    'number': lot,
                    'phase': phase }, true);

                if(sched.length !== 1) { //first time we've see this lot
                    var newLot = {
                        'number': lot,
                        'phase': phase,
                        'date_added': new Date(),
                        'active': true,
                        'date_scheduled': new Date(lot.start_date)
                    }
                    success.lots.push(newLot);
                } else {
                    sched[0].active = true;
                    sched[0].rescheduled = false;
                    sched[0].completed = false;
                    sched[0].date_scheduled = new Date(lot.start_date);
                }

                success.$update();
            }, function(error) {
                toaster.pop('error', 'System Lot DB Error', error);
            });
        }
        
        return {
            add: add,
            schedule: schedule,
            reschedule: reschedule,
            complete: complete,
            remove: remove,
            reset: reset,
            reopen: reopen
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-lots/public/services/lot-service.js